import React from 'react';

export default function NotificationAlertIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...oRest}
    >
      <path
        d="M6.64838 16.2C7.21249 16.6979 7.95349 17 8.76504 17C9.5766 17 10.3176 16.6979 10.8817 16.2M1.00016 4.05591C0.988678 2.89484 1.61466 1.8106 2.62593 1.24M16.5268 4.05592C16.5382 2.89484 15.9122 1.8106 14.901 1.24M13.565 5.8C13.565 4.52696 13.0593 3.30606 12.1592 2.40589C11.259 1.50571 10.0381 1 8.76504 1C7.492 1 6.27111 1.50571 5.37093 2.40589C4.47076 3.30606 3.96504 4.52696 3.96504 5.8C3.96504 8.27215 3.34142 9.96477 2.64477 11.0843C2.05714 12.0287 1.76333 12.5009 1.7741 12.6326C1.78603 12.7785 1.81693 12.8341 1.93446 12.9213C2.04061 13 2.51912 13 3.47613 13H14.054C15.011 13 15.4895 13 15.5956 12.9213C15.7132 12.8341 15.7441 12.7785 15.756 12.6326C15.7668 12.5009 15.4729 12.0287 14.8853 11.0843C14.1887 9.96477 13.565 8.27215 13.565 5.8Z"
        stroke={stroke || "#004DFF"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
